// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"CargarMasButton1_buttonContainer__T1mYq","CargarMAS":"CargarMasButton1_CargarMAS__2aJux"};